import { useCallback, useEffect, useState } from 'react';

import { EtatConventionnementResponseDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

interface FetchEtatConventionnementResult {
  etat: EtatConventionnementResponseDto | null;
  fetchEtat: () => Promise<void>;
  fetchInProgress: boolean;
  errorOccured: boolean;
}

export function useFetchEtatConventionnement(
  idCorrelationUniteFo?: string,
  typeUniteFo?: string,
  codeInsee?: string,
): FetchEtatConventionnementResult {
  const [etat, setEtat] = useState<EtatConventionnementResponseDto | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [errorOccured, setErrorOccured] = useState<boolean>(false);
  const { AdminFonctionnelControllerApi } = useApi();
  const behaviourOnError = useHandleBackErrors();

  const fetchEtat = useCallback(async () => {
    setEtat(null);
    setErrorOccured(false);

    setLoading(true);
    await AdminFonctionnelControllerApi.etatUsingGET({
      idCorrelationUniteFo,
      typeUniteFo,
      codeInsee,
    })
      .then(etat => {
        setEtat(etat);
      })
      .catch((errorResponse: Response) => {
        setErrorOccured(true);
        behaviourOnError(errorResponse);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    AdminFonctionnelControllerApi,
    idCorrelationUniteFo,
    typeUniteFo,
    codeInsee,
    behaviourOnError,
  ]);

  useEffect(() => {
    void fetchEtat();
  }, [
    AdminFonctionnelControllerApi,
    idCorrelationUniteFo,
    typeUniteFo,
    codeInsee,
    fetchEtat,
  ]);

  return {
    etat: etat,
    fetchEtat: fetchEtat,
    fetchInProgress: loading,
    errorOccured: errorOccured,
  };
}
